import { addSortAndFilterParams } from "~/utils/addSortAndFilterParams";
import type { ServiceResponse } from "./axios";
import { api, getAuthHeaders } from "./axios";
import type { Caregiver } from "./caregivers";
import type { Patient } from "./patients";
import type { PaginationParams, SearchParams, SortingParams } from "./types";

export interface FileManager {
  id: number;
  uid: string;
  name: string;
  file_type: string;
  status: string;
  path: string;
  updated_at: Date;
  created_at: Date;
  patient?: Patient;
  caregiver?: Caregiver;
}

export const getFileManager = async ({
  page,
  per_page,
  search,
  order_by,
  sort_direction,
}: PaginationParams & SearchParams & SortingParams) => {
  const params: Record<string, string | number> = {
    page,
    per_page,
  };

  const fullParams = addSortAndFilterParams(
    search,
    order_by,
    sort_direction,
    params,
  );

  const { data } = await api.get<ServiceResponse<FileManager[]>>("/files", {
    headers: getAuthHeaders(),
    params: fullParams,
  });

  return data;
};

export interface DownloadFileResponse {
  file: FileManager;
  temporary_url: string;
}

export const downloadFile = async (fileId: number) => {
  const { data } = await api.get<ServiceResponse<DownloadFileResponse>>(
    `/files/${fileId}/download`,
    {
      headers: getAuthHeaders(),
    },
  );

  return data;
};
